import { Button, Fab } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

export interface TableAddButtonProps {
  onClick: () => any;
  title: string;
  className?: string;
}

export default function TableAddButton(props: TableAddButtonProps) {
  return (
    <>
      <Button
        startIcon={<AddIcon />}
        className={`add-btn initial-text ${props.className || ""}`}
        sx={{ display: { md: "flex", xs: "none" }, position: "absolute" }}
        onClick={props.onClick}
        variant="contained"
        data-testid={props.title}
      >
        {props.title}
      </Button>
      <Fab
        onClick={props.onClick}
        sx={{ display: { md: "none", xs: "flex" } }}
        className={`add-btn initial-text ${props.className || ""}`}
        size="small"
        color="primary"
        aria-label="add"
        data-testid={props.title}
      >
        <AddIcon />
      </Fab>
    </>
  );
}
